export function copyObj(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export function isEmpty (obj) {
  return obj == undefined || obj == null || obj == "" || obj == {} || obj == []
}
